import { fetchGet, fetchPost, fetchPostJson } from './fetch'

export const signInUsernamePassword = (username, password) => {
  return fetchPostJson('/api/account/sign-in', { username, password })
}

export const signOut = async () => {
  return await fetchPost('/api/account/sign-out')
}

export const getUser = () => {
  return fetchGet('/api/account/user')
}

export const getTwoFactorAuthSecret = () => {
  return fetchGet('/api/account/two-factor-auth-secret')
}

export const postRegisterTwoFactorAuth = code => {
  return fetchPostJson('/api/account/two-factor-auth-register', { verification_code: code })
}

export const postVerifyTwoFactorAuth = code => {
  return fetchPostJson('/api/account/two-factor-auth-verify', { verification_code: code })
}
